'use client';
import React, { useEffect } from 'react';
import Script from 'next/script';
import Container from '@/components/layout/Container';

export default function AllReviews() {
  const yotpoAppKey = process.env.NEXT_PUBLIC_YOTPO_APP_KEY;
  const yotpoInstance = process.env.NEXT_PUBLIC_YOTPO_ALL_REVIEWS_INSTANCE_ID;

  // Destroy Yotpo and recreate it on page change
  useEffect(() => {
    if (typeof window['yotpo'] !== 'undefined') {
      const api = new window.Yotpo.API(window.yotpo);
      api.refreshWidgets();
    }
  }, []);

  return (
    <>
      <Container>
        <section id="all-reviews" className="pb-10">
          <div className="mb-7">
            <div className="max-w-container mx-auto">
              <h2 className="h4 sm:h3 mt-15 mb-7 w-full text-center">
                Customer Reviews
              </h2>
              <div className="max-w-container mx-auto w-full">
                <Script
                  src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${yotpoAppKey}`}
                  async
                />
                <div
                  className="yotpo-widget-instance"
                  data-yotpo-instance-id={yotpoInstance}
                />
              </div>
            </div>
          </div>
        </section>
      </Container>
    </>
  );
}
